module.exports = __webpack_public_path__ + "img/02n_marketing.739dfe28.jpg";